<template>
  <div class="myReal">
    <div class="header">
      <i
        class="iconfont iconzuojiantou"
        style="font-size:20px;color:#101010"
        @click="goBack"
      ></i>
      <span>我的实名</span>
    </div>
    <div class="header-one">
      <img
        src="../../assets/img/real/touxiang.png"
        width="60px"
        height="60px"
        alt=""
      />
      <p>我的实名认证信息</p>
    </div>
    <div class="content">
      <van-field
        :value="formData.userName"
        label="姓名"
        readonly
        :rules="[{ required: true }]"
      />
    </div>
    <div class="content1">
      <van-field
        label="证件类型"
        value="身份证"
        readonly
        :rules="[{ required: true }]"
      />
      <van-field
        :value="formData.idNo"
        label="身份证号"
        readonly
        :rules="[{ required: true }]"
      />
    </div>
    <div class="content2">
      <p class="shiming">实名认证方式</p>
      <div class="con">
        <img
          src="../../assets/img/real/yinhangka.png"
          width="18px"
          height="14px"
          alt=""
        />
        <p class="bank">银行卡</p>
      </div>
    </div>
    <div class="personal">个人隐私信息安全保障中</div>
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config";
export default {
  data() {
    return {
      formData: {
        userName: "",
        idNo:"",
      }
    };
  },

  mounted() {
    this.fetchHomeInfo()
  },

  methods: {
    fetchHomeInfo(){
      http.post(config.h5UserHomeInfo).then(({code,data})=>{
        this.formData.userName=data.userName;
        this.formData.idNo=data.idNo;
      })
    },
    goBack(){
    this.$router.go(-1)
  }
  },
};
</script>
<style>
.van-cell {
  padding: 32px 32px;
}
.confirmInformation .van-field--error .van-field__control,
.van-field--error .van-field__control::placeholder {
  color: #cbcccf;
}
.confirmInformation .van-field__error-message {
  text-align: right;
}
.van-field__control {
  text-align: right;
}
</style>
<style lang="less" scoped>
.myReal {
  width: 750px;
  height: 100%;
  background-color: #f5f5f5;
  .header {
    background-color: #fff;
    position: relative;
    height: 80px;
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ececec;
    i {
      position: absolute;
      left: 10px;
      top: 20px;
      // font-weight: 600;
    }
    span {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      // font-weight: 600;
      color: #333333;
      line-height: 60px;
    }
  }
  .header-one {
    text-align: left;
    height: 189px;
    background-color: #fff;
    display: flex;
    align-items: center;
    img {
      align-items: center;
      padding-left: 30px;
    }
    p {
      padding-left: 20px;
      font-size: 36px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .content {
    height: 105px;
    background-color: #fff;
    margin-top: 20px;
  }
  .content1 {
    height: 220px;
    background-color: #fff;
    margin-top: 20px;
  }
  .content2 {
    height: 105px;
    background-color: #fff;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .shiming{
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      padding-left: 30px;
    }
    .con {
      display: flex;
      align-items: center;
      padding-right: 30px;
      img{
        align-items: center;
      }
      .bank{
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0681fd;
        padding-left: 10px;
      }
    }
  }
  .personal {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myReal/index.vue